import isEmailValidator from 'validator/lib/isEmail'
import isAscii from 'validator/lib/isAscii'

export const isEmail = {
  email: (value: string) => {
    return !value || (isEmailValidator(value) && isAscii(value))
  },
}
